<template>
  <div class="content ">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <div class="row">
                <div class="col-10">
                  <h4 class="card-title">İşbirliği Grupları</h4>
                  <p class="card-category">Yönettiğiniz ve partnerlik yapılan grupları buradan daha kolay yönetebilirsiniz.</p>
                </div>
                <div class="col-2">
                  <button type="submit" class="btn btn-success btn-fill float-right mr-3" @click="createNew()">
                    Yeni Grup Ekle
                  </button>
                </div>

              </div>

            </template>


            <table class="table table-hover table-striped">
              <thead>
                <slot name="columns">
                  <tr>
                    <th v-for="column in tableColumns" :key="column">{{ column }}</th>
                  </tr>
                </slot>
              </thead>
              <tbody>
                <tr v-for="(group) in groups" :key="group._id">
                  <slot :row="group">
                    <td>{{ group.code }}</td>
                    <td>{{ group.title }}</td>
                    <td>{{ group.membersLength }}</td>
                    <td><button @click="openDeleteModal(group)"><i class="nc-icon nc-simple-remove"></i></button></td>
                    <td><button @click="editGroup(group._id)"><i class="nc-icon nc-settings-tool-66"></i></button>
                    </td>
                  </slot>
                </tr>
              </tbody>
            </table>
            <nav aria-label="...">
              <ul class="pagination text-center" style="margin-left: 45%;">

                <li class="page-item"
                  v-for="i of (pagination.totalPages > 1 ? Array.from(Array(pagination.totalPages).keys()).slice(pagination.currentPage > 3 ? pagination.currentPage - 3 : 0, pagination.currentPage + pagination.layOutMax) : [0])"
                  :class="pagination.currentPage == i + 1 ? 'active' : ''" :key="i" @click="paginationGet(i + 1)"><a
                    class="page-link">{{ i + 1 }}</a></li>



              </ul>
            </nav>
          </card>

        </div>


        <div class="modal fade show bg-gray" tabindex="-1"
          :style="deleteModal.isOpened == true ? 'display: block;' : 'display: none;'" aria-modal="true" role="dialog">
          <div class="modal-dialog" v-if="deleteModal.group">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLiveLabel">Grupu silmek istediğinize emin misiniz?</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                  @click="deleteModal.isOpened = false">
                  <span aria-hidden="true">×</span>
                </button>
              </div>

              <div class="modal-body">
                  <label><strong>Grup Kodu:</strong> {{ deleteModal.group.code }}</label><br>
                <label><strong>Grup Adı:</strong> {{ deleteModal.group.title }}</label><br>
                <label><strong>Kayıtlı Üye:</strong> {{ deleteModal.group.membersLength }}</label><br>

              </div>
              <div class="modal-footer">

                <button type="button" @click="openDeleteModal(null)" class="btn btn-secondary"
                  data-dismiss="modal">Kapat</button>
                <button type="button" @click="deleteGroup(deleteModal.group._id)" class="btn btn-primary">Sil!</button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../../services/collection.service.js";


const tableColumns = ['Grup Kodu', 'Grup Adı', 'Kayıtlı Üye', 'Sil', 'Düzenle']
export default {
  components: {
    Card
  },
  data() {
    return {
      tableColumns,
      groups: [],
      pagination: {
        currentPage: 1,
        totalPages: 0,
        itemsPerPage: 10,
        layOutMax: 3
      },
      queryText: '',
      deleteModal: {
        isOpened: false,
        group: null
      },
      searchInterval: null
    }
  },
  mounted() {
    this.getGroups();

  },
  methods: {
    paginationGet(i) {
      this.pagination.currentPage = Number(i);
      this.getGroups();
      window.scroll({ top: 0, behavior: "smooth" })
    },
    getGroups() {
      let q = { title: { $regex: this.queryText, $options: 'i' } };
      let p = {};
      let o = { skip: (this.pagination.currentPage - 1) * this.pagination.itemsPerPage, limit: this.pagination.itemsPerPage, sort: { createdAt: 1 } }

      let query = `q=${JSON.stringify(q)}&p=${JSON.stringify(p)}&o=${JSON.stringify(o)}`

      CollectionService.getCollection('affiliate-group', query).then((res) => {
        if (res.success == true) {
          this.groups = res.affiliateGroups;
          this.pagination.totalPages = Math.ceil(res.count / this.pagination.itemsPerPage);
        } else {
          console.log('error');
        }
      })
    },
    deleteGroup(_id) {
      CollectionService.deleteItem('affiliate-group', _id).then((res) => {
        this.notifyVue('bottom', 'right', 'danger', ` ${this.deleteModal.group.title} grup silindi.`)
        this.deleteModal.isOpened = false;
        this.deleteModal.group = null;
        this.getGroups();
      })
    },
    openDeleteModal(group) {
      this.deleteModal.isOpened = !this.deleteModal.isOpened
      this.deleteModal.group = group;
    },
    editGroup(_id) {
      this.$router.push(`/admin/affiliate-groups/${_id}`);
    },
    createNew() {
      this.$router.push(`/admin/affiliate-groups/create`);
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notifications.notify(
        {
          message: JSON.stringify(message),
          icon: '',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type
        })
    }
  }
}
</script>
<style></style>